import { Tabs, type TabsProps } from 'antd';

type TabItem = NonNullable<TabsProps['items']>[number];

export interface BaseTabItem extends TabItem {
  count?: number;
}

export interface BaseTabsProps extends Omit<TabsProps, 'items'> {
  items?: BaseTabItem[];
  /** separate 让导航独立成卡，正文保留原生页签的挂载与缓存行为。 */
  appearance?: 'plain' | 'surface' | 'separate';
}

/** 统一页签和可选数量外观，业务计数及切换逻辑由调用方提供。 */
export default function BaseTabs({
  items,
  className,
  appearance = 'plain',
  ...props
}: BaseTabsProps) {
  return (
    <Tabs
      {...props}
      className={[
        'base-tabs',
        appearance === 'separate' && 'base-tabs-separated min-w-0',
        appearance === 'surface' &&
          'base-tabs-surface min-w-0 px-6 border border-solid border-border rounded-lg bg-container max-[992px]:px-3',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
      items={items?.map(({ count, label, ...item }) => ({
        ...item,
        label: (
          <span className="base-tabs-label inline-flex items-center gap-1.5 whitespace-nowrap">
            {label}
            {count !== undefined && ' '}
            {count !== undefined && (
              <span className="base-tabs-count py-px px-1 rounded-[3px] bg-[var(--muou-group-bg)] text-muted text-[11px] leading-5 [text-shadow:none]">
                {count}
              </span>
            )}
          </span>
        ),
      }))}
    />
  );
}
